
import { FilmInventory } from "@/types/inventory";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { FilmTableHeader } from "./FilmTableHeader";
import { FilmStatusBadge } from "./FilmStatusBadge";
import { FilmActions } from "./FilmActions";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";

interface DesktopInventoryContentProps {
  data: FilmInventory[];
  showTransfer?: boolean;
  onSort?: (field: string) => void;
  onActionComplete: () => void;
}

export function DesktopInventoryContent({
  data,
  showTransfer = false,
  onSort,
  onActionComplete
}: DesktopInventoryContentProps) {
  const navigate = useNavigate();

  const formatExpirationDate = (dateString: string | null) => {
    if (!dateString) return 'N/A';
    try {
      return format(new Date(dateString), 'MMMM yyyy');
    } catch {
      return 'Invalid date';
    }
  };

  return (
    <div className="w-full">
      <Table>
        <FilmTableHeader />
        <TableBody>
          {data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center py-10">
                No film in this category.
              </TableCell>
            </TableRow>
          ) : (
            data.map((film) => (
              <TableRow 
                key={film.id} 
                className="hover:bg-muted/50 cursor-pointer"
                onClick={() => navigate(`/inventory/${film.id}`)}
              >
                <TableCell className="font-medium w-[12.5%]">{film.brand}</TableCell>
                <TableCell className="w-[12.5%]">{film.film_name}</TableCell>
                <TableCell className="hidden md:table-cell w-[12.5%]">{film.film_type}</TableCell>
                <TableCell className="w-[12.5%]">
                  <FilmStatusBadge status={film.status} />
                </TableCell>
                <TableCell className="hidden md:table-cell w-[12.5%]">{film.iso}</TableCell>
                <TableCell className="w-[12.5%]">{film.quantity}</TableCell>
                <TableCell className="hidden md:table-cell w-[12.5%]">
                  {formatExpirationDate(film.expiration_date)}
                </TableCell>
                <TableCell 
                  className="w-[12.5%] text-right"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FilmActions 
                    film={film} 
                    showTransfer={showTransfer} 
                    onActionComplete={onActionComplete} 
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
